/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecordMentionUsageRequest
 */
export interface RecordMentionUsageRequest {
    /**
     * 
     * @type {string}
     * @memberof RecordMentionUsageRequest
     */
    type: RecordMentionUsageRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RecordMentionUsageRequest
     */
    id: string;
}


/**
 * @export
 */
export const RecordMentionUsageRequestTypeEnum = {
    User: 'user',
    Group: 'group'
} as const;
export type RecordMentionUsageRequestTypeEnum = typeof RecordMentionUsageRequestTypeEnum[keyof typeof RecordMentionUsageRequestTypeEnum];


/**
 * Check if a given object implements the RecordMentionUsageRequest interface.
 */
export function instanceOfRecordMentionUsageRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function RecordMentionUsageRequestFromJSON(json: any): RecordMentionUsageRequest {
    return RecordMentionUsageRequestFromJSONTyped(json, false);
}

export function RecordMentionUsageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordMentionUsageRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'id': json['id'],
    };
}

export function RecordMentionUsageRequestToJSON(value?: RecordMentionUsageRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'id': value.id,
    };
}

